import { z } from "zod";

export const threadSchema = z.object({
  threadName: z.string(),
  threadId: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const createdThreadSchema = z.object({
  createdAt: z.string().datetime(),
  threadId: z.string(),
});

export const threadMessageSchema = z.object({
  id: z.string(),
  textContent: z.string(),
  createdAt: z.string().datetime(),
  role: z.enum(["assistant", "user"]),
  feedbackScore: z.number().nullable().optional(),
});

export const allThreadsResponseSchema = z.object({
  pageNumber: z.number(),
  pageSize: z.number(),
  totalResults: z.number(),
  results: z.array(threadSchema),
});

export const threadMessagesSchema = z.array(threadMessageSchema);

export const injectReportsRequestBodySchema = z.object({
  reports: z.array(
    z.object({
      reportType: z.literal("spendAnalysis"),
      reportOutput: z.enum(["suppliers", "paymentMethods"]),
      reportId: z.literal("latest"),
    })
  ),
  streamOutput: z.boolean().optional(),
});

export const feedbackRequestBodySchema = z.object({
  feedbackScore: z.number(),
});

export const feedbackResponseSchema = z.string();

export type Thread = z.infer<typeof threadSchema>;
export type CreatedThread = z.infer<typeof createdThreadSchema>;
export type ThreadMessage = z.infer<typeof threadMessageSchema>;
export type ThreadMessages = z.infer<typeof threadMessagesSchema>;
export type AllThreadsResponse = z.infer<typeof allThreadsResponseSchema>;
export type InjectReportsRequestBody = z.infer<
  typeof injectReportsRequestBodySchema
>;
export type FeedbackRequestBody = z.infer<typeof feedbackRequestBodySchema>;
export type FeedbackResponse = z.infer<typeof feedbackResponseSchema>;
